import { AccessTokensSection } from '../components/mcp/AccessTokensSection';
import { ConnectedClientsSection } from '../components/mcp/ConnectedClientsSection';
import { McpServerCard } from '../components/mcp/McpServerCard';
import { SettingsSectionHeader } from '../components/SettingsSectionHeader';

export function McpIntegrationSection(): React.ReactElement {
  return (
    <>
      <SettingsSectionHeader
        title="Model Context Protocol"
        description="Connect Claude Desktop, ChatGPT, VS Code, and other MCP clients to your workspace."
      />
      <section className="space-y-6">
        <McpServerCard />
        <ConnectedClientsSection />
        <AccessTokensSection />
      </section>
    </>
  );
}
